import { grey300 } from "styles";

export const styles = {
  modal: {
    width: "480px",
    borderRadius: "16px",
  },
  closeButton: {
    position: "absolute",
    top: "20px",
    right: "24px",
    padding: 0,
    zIndex: 2,
    color: "#393939",

    ":hover": {
      border: "none",
    },
  },
  content: {
    p: 0,
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  urlWrapper: {
    backgroundColor: grey300,
    p: 2,
    mb: 2,
    borderRadius: "8px",
    maxWidth: "100%",
  },
  qrContainer: {
    cursor: "pointer",
    mb: 4,
  },
};
